/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';

const EditVacancyButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useVacancyPublicationUrl();

  return <EditButton {...props} path={id => getUpdateEntityUrl(id)} />;
};

export default EditVacancyButton;
